<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Add Vendor</h1>
    </div>

    <!-- Breadcrumbs -->
    <!-- <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>TBM Points</b> /
      <b>Survey</b>
    </div> -->
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div style="margin-bottom: 30px;"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Add Charity</h4>
            <br>
            <div class="row">
              <div class="col-12">
                <label>Name</label>
                <input type="text" class="form-control" style="margin-bottom: 10px;" v-model="name" />
                <label>Description</label>
                <input type="text" class="form-control" style="margin-bottom: 10px;" v-model="description" />
                <label>Image</label>
                <input type="file" id="file" ref="image" class = "form-control" v-on:change="handleFileUpload()">
                <label>Banner</label>
                <input type="file" id="file" ref="banner" class = "form-control" v-on:change="handleFileUpload()">
                <label>Start Date</label>
                <input type="date" class="form-control" style="margin-bottom: 10px;" v-model="start_at" />
                <label>End Date</label>
                <input type="date" class="form-control" style="margin-bottom: 10px;" v-model="end_at" />
                <label >Activation Status</label>
                <div class="row">
                  <label class="radio radio-success ml-3">
                      <input type="radio" name="radio" v-model="active" v-bind:value="a">
                      <span>Active</span>
                      <span class="checkmark"></span>
                  </label>
                  <label class="radio radio-danger ml-3">
                      <input type="radio" name="radio" v-model="active"  v-bind:value="b">
                      <span>Inactive</span>
                      <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 30px;">
              <div class="col-12 text-center">
               
                <span class="col-4"></span>
                <button class="btn btn-primary btn-rounded col-2" @click="onSubmit()">Submit</button>
                <span class="col-4"></span>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";
import dateManipulation from "@/mixins/dateManipulation";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
  name: "charity-add",
  mixins: [dateManipulation],
  props: ['edit'],
  components: {vSelect},

  data() {
    return {
      name: '',
      description: '',
      image: '',
      banner: '',
      start_at: '',
      end_at: '',
      active: 0,
      a: 1,
      b: 0
    };
  },

  methods: {
    onSubmit() {
      let token = this.checkToken();
      let formdata = new FormData();
      swal({
        icon: 'warning',
        text: 'Are you sure?',
        buttons: ['Cancel', 'Yes']
      }).then(confirm => {
        if(!confirm) {
          return;
        }
        formdata.append("name", this.name);
        formdata.append("description", this.description);
        formdata.append("image", this.image);
        formdata.append("banner", this.banner);
        formdata.append("start_at", this.start_at);
        formdata.append("end_at", this.end_at);
        formdata.append("active", this.active);
        axios.post(axios.lpsURL +'/charity/store',  formdata,
          {
            headers: {
              'Authorization' : 'Bearer ' + token,
              "Content-Type": "multipart/form-data"
            }
          }
        ).then(res =>{
          if(res.data.success) {
            swal({
              icon: 'success',
              text: res.data.message
            })
          } else {
            swal({icon: "error", text: res.data.message})
          }
        })
      })
    },

    // Check Token
    checkToken() {
      let token = localStorage.getItem("token");
      if(token != null) {
        token = JSON.parse(token);
        token = token.access_token;
        return token;
      }
      Swal({
        icon: 'error',
        text: 'Not Authorised'
      });
      return;
    },

    handleFileUpload() {
      this.image = this.$refs.image.files[0];
      this.banner = this.$refs.banner.files[0];
    }
  },

  async created() {
    await this.loadDetails();
  },

  mounted() {
  }
};
</script>
